/*
 * @Author: 刘欢
 * @LastEditors: 刘欢
 * @Date: 2024-03-12 20:11:57
 * @LastEditTime: 2024-03-12 20:11:57
 * @Description: 新增或编辑档案设置
 */

import type {
  ISettingsStore,
  ISettingsModel,
} from '@monorepo/types/document/settings/settings.types';
import { tableUpdate } from '@monorepo/utils';

const initState: ISettingsStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
  },
  keyword: '',
};

const ProductBrandStore: ISettingsModel = {
  namespace: 'productSettingStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return { ...state, tableList };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default ProductBrandStore;
